import { Box } from "@mui/material";
import React from "react";
import { Navigate } from "react-router";
import { getDataSession, LOCAL_STORAGE } from "../helper/session";
import { LoginForm } from "./components/LoginForm";
import { LoginPanel } from "./components/LoginPanel";

const LoginPage = () => {
  const isLogin = getDataSession(LOCAL_STORAGE, "isLogin");
  if (isLogin) {
    return <Navigate to="/" />;
  }
  return (
    <Box className="flex h-screen w-screen items-center justify-center">
      <Box
        className="flex flex-row items-stretch flex-1"
        style={{ maxWidth: 1000, height: 600 }}
      >
        <LoginPanel />
        <LoginForm />
      </Box>
    </Box>
  );
};

export default LoginPage;
